import React from 'react';
import { FiAlertCircle, FiAlertTriangle, FiCheck } from 'react-icons/fi';
import './tones.css';
import './StatusPill.css';

const horaMinuto = (data) => data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

/**
 * Estado de sincronização de uma seção, ao lado do título. Uma linha, sempre
 * visível; não carrega ações (para isso, InlineNotice).
 *
 * @param {'idle'|'loading'|'retrying'|'partial'|'error'} variant
 * @param {Date} [updatedAt] - Hora da última leitura (variant 'idle')
 */
const StatusPill = ({ variant = 'idle', updatedAt }) => {
  let tone;
  let indicador = null;
  let texto;

  switch (variant) {
    case 'loading':
      tone = 'primary';
      indicador = <span className="status-pill__spinner" />;
      texto = 'Consultando módulos…';
      break;
    case 'retrying':
      tone = 'warning';
      indicador = (
        <span className="status-pill__dots">
          <span className="status-pill__dot" />
          <span className="status-pill__dot" />
          <span className="status-pill__dot" />
        </span>
      );
      texto = 'Reconsultando módulos…';
      break;
    case 'partial':
      tone = 'warning';
      indicador = <FiAlertTriangle className="status-pill__icon" />;
      texto = 'Atualização parcial';
      break;
    case 'error':
      tone = 'danger';
      indicador = <FiAlertCircle className="status-pill__icon" />;
      texto = 'Falha na consulta';
      break;
    default:
      if (!updatedAt) return null;
      tone = 'neutral';
      indicador = <FiCheck className="status-pill__icon" />;
      texto = `Atualizado às ${horaMinuto(updatedAt)}`;
  }

  return (
    <span className={`status-pill feedback-tone--${tone}`} role="status" aria-live="polite">
      <span className="status-pill__indicator" aria-hidden="true">{indicador}</span>
      {texto}
    </span>
  );
};

export default StatusPill;
